import React from 'react'
import useBreakpoint from '#src/app/hooks/useBreakpoint'
import ExpertsFacepile from '#src/app/components/ExpertsFacepile'
import { Link } from 'react-router-dom'
import { Button } from '@deal/components'
import { generateCreateUrlFromCategory } from '#src/app/services/path'
import { RecommendingExpertsFragment } from '../../../../../components/ExpertsFacepile/RecommendingExperts.generated'
import { RecommendedExpertsForDepartmentComponent } from './RecommendedExpertsForDepartment.generated'
import { SpotlightExpertFragment } from '../../SpotlightExperts.generated'
import { DepartmentType } from '#src/generated/types'
import styles from './styles.css'

interface CTABarTextProps {
  departmentType: DepartmentType
  firstExpert: RecommendingExpertsFragment
  expertCount: number
}

const CTABarText: React.FC<CTABarTextProps> = ({ departmentType, firstExpert, expertCount }) => {
  const isLargerThanSm = useBreakpoint('sm')

  switch (departmentType) {
    case DepartmentType.CYCLING:
      return (
        <>
          Connect with{' '}
          {isLargerThanSm && (
            <>
              <span className={styles.expertName}>{firstExpert.shortName}</span> or{' '}
            </>
          )}
          one of our <strong>{expertCount} Cycling Experts</strong>
        </>
      )

    case DepartmentType.GOLF:
      return (
        <>
          Connect with{' '}
          {isLargerThanSm && (
            <>
              <span className={styles.expertName}>{firstExpert.shortName}</span> or{' '}
            </>
          )}
          one of our <strong>{expertCount} Golf Experts</strong>
        </>
      )

    case DepartmentType.WINTER_SPORTS:
      return (
        <>
          Connect with{' '}
          {isLargerThanSm && (
            <>
              <span className={styles.expertName}>{firstExpert.shortName}</span> or{' '}
            </>
          )}
          one of our <strong>{expertCount} Winter Sports Experts</strong>
        </>
      )

    case DepartmentType.FISHING:
      return (
        <>
          Connect with{' '}
          {isLargerThanSm && (
            <>
              <span className={styles.expertName}>{firstExpert.shortName}</span> or{' '}
            </>
          )}
          one of our <strong>{expertCount} Fishing Experts</strong>
        </>
      )

    default:
      return (
        <>
          Connect with{' '}
          {isLargerThanSm && (
            <>
              <span className={styles.expertName}>{firstExpert.shortName}</span> or{' '}
            </>
          )}
          one of our <strong>{expertCount} experts</strong>
        </>
      )
  }
}

interface CTABarProps {
  isExpertPlayerVisible: boolean
  featuredExpert?: SpotlightExpertFragment
}

const CTABar: React.FC<CTABarProps> = ({ isExpertPlayerVisible, featuredExpert }) => {
  return (
    <div className={styles.container}>
      {isExpertPlayerVisible && featuredExpert && (
        <div className={styles.ctaBar}>
          <RecommendedExpertsForDepartmentComponent
            variables={{
              query: {
                departmentIds: [featuredExpert.department.id],
                facetedSearch: false
              }
            }}
          >
            {({ data }) => {
              if (data && data.expertSearchConnection.edges.length > 0) {
                return (
                  <>
                    <ExpertsFacepile
                      avatarSize={32}
                      className={styles.expertsFacepile}
                      experts={data.expertSearchConnection.edges.map(
                        expertSearchConnetionEdge => expertSearchConnetionEdge.node
                      )}
                      displayThreshold={6}
                    />
                    <div className={styles.ctaCopy}>
                      <CTABarText
                        departmentType={featuredExpert.department.type}
                        firstExpert={data.expertSearchConnection.edges[0].node}
                        expertCount={data.expertSearchConnection.count}
                      />
                    </div>
                  </>
                )
              }

              return null
            }}
          </RecommendedExpertsForDepartmentComponent>

          <Link
            to={generateCreateUrlFromCategory({
              categorySlug: featuredExpert.department.topLevelCategory.slug,
              sourceKey: 'logged-out-home-experts-facepile'
            })}
            className={styles.buttonLink}
          >
            <Button size="medium">Get started</Button>
          </Link>
        </div>
      )}
    </div>
  )
}

export default CTABar
